import { EnumHelper } from '@canvas/four-r-digital';
import {
  DataTableColumn,
  RowAction,
} from '../../../../common/components/data-table';
import { IProject } from '../../dtos/project';
import { ProjectStatus } from '@canvas/canvas-lib';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

const title: DataTableColumn = {
  headerLabel: 'Title',
  propertyType: 'text',
  propertyName: 'title',
  bold: true,
};

const category: DataTableColumn = {
  headerLabel: 'Category',
  propertyType: 'text',
  propertyName: 'category',
};

const organisation: DataTableColumn = {
  headerLabel: 'Organisation',
  propertyType: 'text',
  propertyName: 'organisationName',
};

const startDate: DataTableColumn = {
  headerLabel: 'Start Date',
  propertyType: 'date',
  propertyName: 'metadata.startDate',
};

const status: DataTableColumn = {
  headerLabel: 'Status',
  propertyType: 'list-item',
  propertyName: 'status',
  listItemValues: EnumHelper.enumToList(ProjectStatus),
};

const actionButton: DataTableColumn = {
  headerLabel: '',
  propertyType: 'action-button',
  propertyName: '',
  align: 'right',
};

const navigateToProject: RowAction<IProject> = {
  labels: ['View more', '>'],
  execute: (dataRow: IProject) => {
    inject(Router).navigate([
      '/main/entities',
      dataRow.entityId,
      'projects',
      dataRow.id,
    ]);
  },
};

export const defaultProjectTableColumns = {
  title,
  category,
  organisation,
  startDate,
  status,
  actionButton,
};

export const defaultProjectTableActions = { navigateToProject };
